import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
// 重写 router push 方法， 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}
const routes = [{
		path: '/', //如果是根路径就重定向到login页面
		redirect: 'Login'
	}, {
		//如果浏览器url是'/login'路径，就找 import ('../views/Login.vue')这个页面渲染
		path: '/login',
		name: 'Login',
		meta: {
			title: '后台管理登录',
			requiredPath: false,
		},
		component: () =>
			import('../pages/login/login.vue')
	},
	{
		path: '/main', //主测单航页
		name: 'main',
		meta: {
			title: '首页',
			requiredPath: false,
		},
		component: () =>
			import('../pages/main/mainHome/mainHome.vue'),
		children: [{
			path: '/home',
			name: 'home', //主页
			component: () =>
				import('../pages/main/home/home.vue')
		}, {
			path: '/set',
			name: 'set', //设置页面
			component: () =>
				import('../pages/main/set/set.vue')
		}, {
			path: '/personNews',
			name: 'personNews', //个人中心
			component: () =>
				import('../pages/main/personNews/personNews.vue')
		}, {
			path: '/chargeManage',
			name: 'chargeManage', //充电桩管理
			component: () =>
				import('../pages/main/chargeManage/chargeManage.vue')
		}, {
			path: '/chargingManage',
			name: 'chargingManage', //充电管理
			component: () =>
				import('../pages/main/chargingManage/chargingManage.vue')
		}, {
			path: '/hitchManage',
			name: 'hitchManage', //故障管理
			component: () =>
				import('../pages/main/operationManage/hitchManage/hitchManage.vue')
		}, {
			path: '/settlementRecords',
			name: 'settlementRecords', //结算记录
			component: () =>
				import('../pages/main/settlementRecords/settlementRecords.vue')
		}, {
			path: '/tourManage',
			name: 'tourManage', //巡检记录
			component: () =>
				import('../pages/main/operationManage/tourManage/tourManage.vue')
		}, {
			path: '/hitchFeedback',
			name: 'hitchFeedback', //用户故障反馈
			component: () =>
				import('../pages/main/operationManage/hitchFeedback/hitchFeedback.vue')
		}, {
			path: '/chargeAmount',
			name: 'chargeAmount', //充电金额管理
			component: () =>
				import('../pages/main/runManage/chargeAmount/chargeAmount.vue')
		}, {
			path: '/rechargeAmount',
			name: 'rechargeAmount', //充值金额管理
			component: () =>
				import('../pages/main/runManage/rechargeAmount/rechargeAmount.vue')
		}, {
			path: '/advertisementManage',
			name: 'advertisementManage', //广告配置
			component: () =>
				import('../pages/main/advertisementManage/advertisementManage.vue')
		}, {
			path: '/parameterManage',
			name: 'parameterManage', //参数配置
			component: () =>
				import('../pages/main/parameterManage/parameterManage.vue')
		}, {
			path: '/operationPersonerManage',
			name: 'operationPersonerManage', //运维人员管理
			component: () =>
				import('../pages/main/staffManage/operationPersonerManage/operationPersonerManage.vue')
		}, {
			path: '/operationWithdrawal',
			name: 'operationWithdrawal', //运维人员提现管理
			component: () =>
				import('../pages/main/staffManage/operationWithdrawal/operationWithdrawal.vue')
		}, {
			path: '/rechargeManage',
			name: 'rechargeManage', //充值管理
			component: () =>
				import('../pages/main/rechargeManage/rechargeManage.vue')
		}, {
			path: '/userManage',
			name: 'userManage', //用户管理
			component: () =>
				import('../pages/main/userManage/userManage.vue')
		}, {
			path: '/accountManage',
			name: 'accountManage', //账号管理
			component: () =>
				import('../pages/main/accountManage/accountManage.vue')
		}, {
			path: '/permissionManage',
			name: 'permissionManage', //权限管理
			component: () =>
				import('../pages/main/permissionManage/permissionManage.vue')
		}, {
			path: '/menuConfiguration',
			name: 'menuConfiguration', //菜单管理
			component: () =>
				import('../pages/main/menuConfiguration/menuConfiguration.vue')
		}, {
			path: '/cardManage',
			name: 'cardManage', //卡管理
			component: () =>
				import('../pages/main/cardManage/cardManage.vue')
		}, {
			path: '/operationsAnalysis',
			name: 'operationsAnalysis', //运营分析
			component: () =>
				import('../pages/main/operationsAnalysis/operationsAnalysis.vue')
		}, {
			path: '/businessPowerManange',
			name: 'businessPowerManange', //直营商电费管理
			component: () =>
				import('../pages/main/businessPowerManange/businessPowerManange.vue')
		}, {
			path: '/equipmentInstallationManagement',
			name: 'equipmentInstallationManagement', //设备管理
			component: () =>
				import('../pages/main/equipmentInstallationManagement/equipmentInstallationManagement.vue')
		}, 
		// {
		// 	path: '/equipmentfailureorabnormal',
		// 	name: 'equipmentfailureorabnormal', //设备故障或异常管理
		// 	component: () =>
		// 		import('../pages/main/equipmentfailureorabnormal/equipmentfailureorabnormal.vue')
		// }, 
		{
			path: '/operatorManagement',
			name: 'operatorManagement', //运营商管理
			component: () =>
				import('../pages/main/operatorManagement/operatorManagement.vue')
		}, 
		{
			path: '/reconciliationRecords',
			name: 'reconciliationRecords', //对账记录
			component: () =>
				import('../pages/main/reconciliationRecords/reconciliationRecords.vue')
		}, {
			path: '/versionManagement',
			name: 'versionManagement', //版本管理
			component: () =>
				import('../pages/main/versionManagement/versionManagement.vue')
		}, {
			path: '/remoteUpgrade',
			name: 'remoteUpgrade', //远程升级
			component: () =>
				import('../pages/main/remoteUpgrade/remoteUpgrade.vue')
		},{
			path: '/listSysNotice',
			name: 'listSysNotice', //公告配置
			component: () =>
				import('../pages/main/listSysNotice/listSysNotice.vue')
		}
		],

	}, {
		// 404页面，必须放在最下面，浏览器url找不到对应的路由时，就会跳转到这个页面
		path: "/:pathMatch(.*)",
		component: () =>
			import("@/pages/NotFound/NotFound.vue"),
	}

]

const router = new VueRouter({
	mode: 'hash', //history
	routes
})

// 进入之前路由元信息配置守卫 requiredPath为true, 适合守卫多个页面 vue3next() 变成return true
router.beforeEach((to, from, next) => {
	// console.log(to)
	// console.log(from)
	// console.log(next)
	if (sessionStorage.getItem('token')) {
		next()
	} else {
		if (to.meta.requiredPath) { //没有token requiredPath为true 守卫不让进,跳入login
			next('/Login')
		} else {
			next()
		}
	}
})
// 导航后置守卫(当你真正进入到某个页面之后才执行)
// router.afterEach((to, from) => {
//     // 设置路由的标题 (可自定义)
//     document.title = to.meta.title || '后台'
//         // 将所有的页面切换之后滚动到最顶部
//     window.scrollTo(0, 0);
// })
export default router